import { defineMessages } from 'react-intl';

export default defineMessages({
  ok: {
    id: 'sentinel.common.transferStateDescriptionModal.ok',
    defaultMessage: 'Ok',
  },
  close: {
    id: 'sentinel.common.transferStateDescriptionModal.close',
    defaultMessage: 'Close',
  },
  title: {
    id: 'sentinel.common.transferStateDescriptionModal.title',
    defaultMessage: 'Transfer States',
  },
  transferStateHeader: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateHeader',
    defaultMessage: 'Transfer State',
  },
  descriptionHeader: {
    id: 'sentinel.common.transferStateDescriptionModal.descriptionHeader',
    defaultMessage: 'Description',
  },
  transferStateReviewPending: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateReviewPending',
    defaultMessage: 'Transfer has unresolved Prescribed Actions and has not been Rejected outright.',
  },
  transferStateSuspended: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateSuspended',
    defaultMessage: 'The wire deposit needs further review.',
  },
  transferStateWireDepositDetails: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateWireDepositDetails',
    defaultMessage: 'The wire deposit has been reviewed.',
  },
  transferStateApproved: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateApproved',
    defaultMessage: 'Reviews are complete or not required, transfer is approved.',
  },
  transferStateFundsPosted: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateFundsPosted',
    defaultMessage: "The transfer has been posted to the customer's account.",
  },
  transferStatePositionPosted: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStatePositionPosted',
    defaultMessage: 'A position has been posted to the account.',
  },
  transferStateSentToBank: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateSentToBank',
    defaultMessage: 'The transfer has been sent to the corresponding financial institution.',
  },
  transferStateCompleted: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateCompleted',
    defaultMessage: 'The transfer is complete and has been sent to the bank.',
  },
  transferStateRejectedFundsNotPosted: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateRejectedFundsNotPosted',
    defaultMessage:
      'Funds were not posted because transfer failed (transfer not found, transfer above daily limit, posting to ledger failed, etc.)',
  },
  transferStateRejectedPositionNotPosted: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateRejectedPositionNotPosted',
    defaultMessage: 'Position not posted; transfer failed to post.',
  },
  transferStatePendingPrinting: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStatePendingPrinting',
    defaultMessage: 'The check withdrawal is waiting for print confirmation.',
  },
  transferStateRejectedNotSentToBank: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateRejectedNotSentToBank',
    defaultMessage: 'The transfer is complete and has failed to send to the bank.',
  },
  transferStateRejectedUnapproved: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateRejectedUnapproved',
    defaultMessage: 'Reviews are complete, transfer is NOT approved.',
  },
  transferStateRejectedValidationFailed: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateRejectedValidationFailed',
    defaultMessage: 'Validation is complete, transfer is NOT valid.',
  },
  transferStateStoppedPayment: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateStoppedPayment',
    defaultMessage: 'The payment was stopped before processing.',
  },
  transferStateSendToBankFailed: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateSendToBankFailed',
    defaultMessage: 'The transfer instructions failed upon submittal to the corresponding financial institution.',
  },
  transferStateFundsReturned: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateFundsReturned',
    defaultMessage: 'The funds have been backed out for a returned transfer.',
  },
  transferStatePostponed: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStatePostponed',
    defaultMessage: 'The transfer has been postponed.',
  },
  transferStateReturned: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateReturned',
    defaultMessage: 'The transfer funds have been returned to the original source.',
  },
  transferStateCanceled: {
    id: 'sentinel.common.transferStateDescriptionModal.transferStateCanceled',
    defaultMessage:
      'The transfer request has been canceled by the broker or the submitting customer. Canceled transfers cannot be re-opened.',
  },
  transferStateSuspendedPendingReturn: {
    id: 'sentinel.common.transferStateDescriptionModal.SuspendedPendingReturn',
    defaultMessage: 'The funds are in the suspense account; transfer is intended to go through return process.',
  },
  transferStateReturnedWaitingForReversal: {
    id: 'sentinel.common.transferStateDescriptionModal.ReturnedWaitingReversal',
    defaultMessage: 'The return failed; wire deposit funds are still in Suspense.',
  },
  transferStateCanceledWaitingForReversal: {
    id: 'sentinel.common.transferStateDescriptionModal.CanceledWaitingForReversal',
    defaultMessage: 'The transfer was canceled; waiting for reversal.',
  },
  transferStateFailedAtBank: {
    id: 'sentinel.common.transferStateDescriptionModal.FailedAtBank',
    defaultMessage: 'The wire was rejected by wire processor.',
  },
  transferStateVoided: {
    id: 'sentinel.common.transferStateDescriptionModal.StateVoided',
    defaultMessage: 'The check has been voided.',
  },
  transferStateFailedToSuspend: {
    id: 'sentinel.common.transferStateDescriptionModal.FailedToSuspend',
    defaultMessage: 'The wire deposit failed to post to Suspense.',
  },
  transferStatePayPalReviewPending: {
    id: 'sentinel.common.transferStateDescriptionModal.PayPalReviewPending',
    defaultMessage: 'The deposit is being reviewed by PayPal.',
  },
  transferStateInvestorReviewPending: {
    id: 'sentinel.common.transferStateDescriptionModal.InvestorReviewPending',
    defaultMessage: 'The real-time payment request is waiting for the investor’s approval.',
  },
  transferStatePaymentScheduled: {
    id: 'sentinel.common.transferStateDescriptionModal.PaymentScheduled',
    defaultMessage: 'The real-time payment has been approved by the investor for a future date.',
  },
  transferStateSentToRtpNetwork: {
    id: 'sentinel.common.transferStateDescriptionModal.SentToRtpNetwork',
    defaultMessage: 'The real-time payment request has been sent to the network.',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferStateDescriptionModal/messages.js